<template>
    <div class='content-container'>
    <div class="content">
        <object class='pdfviewer' type="application/pdf" :data="resource.file.filename">
    <p>The PDF cannot be displayed.</p>
</object>

    </div>
    </div>
</template>

<style>
.pdfviewer {
    width: 1140px;
    height: 80vh;
}
</style>

<script>
export default {
    name: 'pdf-viewer',
    props: ['resource'],
    computed: {
        pdf() {
            return this.$route.params.pdf;
        }
    }
}
</script>